import React, { useState } from "react";

import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import GoodReadsLogo from "../../../assets/icons/Goodreads.png";

import "./cardMemberGrid.scss";

interface CardMemberGridInter {
  member: any;
}

const socialNetworks = {
  facebook: "icon-facebook",
  twitter: "icon-twitter",
  instagram: "icon-instagram",
  linkedin: "icon-linkedin",
  goodreads: "icon-goodreads",
};

const CardMemberGrid = (props: CardMemberGridInter) => {
  const { member } = props;

  const [show, setShow] = useState(false);

  const handleIcons = () => {
    let socialNetworksIcons = Array();

    for (const social in socialNetworks) {
      for (let i = 0; i < member.redesMiembros.length; i++) {
        if (member.redesMiembros[i].includes(social))
          socialNetworksIcons.push(
            <a
              href={member.redesMiembros[i]}
              target="_blank"
              onClick={handleModalClick}
              rel="nofollow noreferrer"
              key={i}
            >
              {!member.redesMiembros[i].includes("goodreads") ? (
                <div
                  className={`${socialNetworks[social]} a-card-member-grid__icons-icon`}
                  key={i}
                ></div>
              ) : (
                <div
                  className={`${socialNetworks[social]} a-card-member-grid__icons-icon`}
                  key={i}
                >
                  <img src={GoodReadsLogo} alt="goodreads-icon" />
                </div>
              )}
            </a>
          );
      }
    }

    return socialNetworksIcons;
  };

  const handleModalClick = (event) => {
    const { id } = event.target;

    if (id === "open-modal") {
      setShow(show ? false : true);
    } else if (id === "modal-dots") {
      setShow(false);
    } else {
      setShow(false);
    }
  };

  return (
    <div className="a-card-member-grid" onClick={handleModalClick}>
      <div className="a-card-member-grid__picture">
        <img
          src={member.imagenPrincipal[0].file.url}
          alt={member.imagenPrincipal[0].title}
        />
      </div>

      <div className="a-card-member-grid__info">
        <p className="a-card-member-grid__info-name">{member.tituloBanner}</p>
        <div className="a-card-member-grid__info-job">
          {documentToReactComponents(member.descripcion.json)}
        </div>
        <p className="a-card-member-grid__info-level">
          {member.tituloDescripcion}
        </p>
      </div>

      {member.redesMiembros && (
        <div className="a-card-member-grid__icons">
          {handleIcons().map((elem) => {
            return elem;
          })}
        </div>
      )}

      <div className="a-card-member-grid__dots">
        <div
          className="icon-ellipsis-v a-card-member-grid__dots-btn"
          id="open-modal"
          onClick={handleModalClick}
        ></div>
      </div>

      <div
        className={`a-card-member-grid__modal ${
          show ? "a-card-member-grid__modal--show" : ""}`
        }
        id="modal-dots"
        onClick={handleModalClick}
      >
        {member.redesMiembros && (
          <div className="a-card-member-grid__modal-window">
            {handleIcons().map((elem) => elem)}
          </div>
        )}
      </div>
    </div>
  );
};

export default CardMemberGrid;
